import React from 'react';
import SignupForm from '../../components/auth/SignupForm.component';
import authBg from '../../assets/images/auth/BG.jpg';
import ChatHelp from '../../components/chat-help/ChatHelp.component';
import { useTranslation } from 'react-i18next';
import SetPasswordForm from '../../components/auth/SetPasswordForm';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MetaComp from '../../components/meta-comp/MetaComp.component';
import LegalLinks from '../../components/auth/LegalLinks.component';

const SetPasswordPage = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const getDecryptId = searchParams.get('id');

    React.useEffect(() => {
        if(!getDecryptId) navigate('/');
    })

    return(
        <main className='cm-page-container cm-auth-page-container d-flex row mx-0'>
            <MetaComp title={t("set_password_page_title")}/>
            <div className='col-sm-12 col-md-6  cm-auth-content-wrap cm-signup-content-wrap d-flex flex-column'>
                <div className='cm-auth-content-inner col-12 flex-grow-1 d-flex flex-column justify-content-center'>
                    <div>
                        <div className="cm-txt-wrap">
                            <h2 className='h2 text-blue-gray-700 cm-fs-24 cm-mmc-font'>{t("reset_password")} <span className='d-block h1 text-primary fw-bold cm-fs-40'>{t("setup_new_password")}</span></h2>
                            <h4 className='h4 text-blue-800'>{t("provide_new_password")}</h4>
                        </div>

                        <hr className='cm-auth-hr bg-blue-gray-300' />

                        <SetPasswordForm t={t} decryptId={getDecryptId} />
                    </div>
                </div>
                <LegalLinks />
            </div>
            <div className='col-sm-6 cm-auth-bg-container py-8 position-relative d-none d-lg-block d-md-block w-md-50' style={{ backgroundImage: `url('${authBg}')` }}>
                <ChatHelp />
            </div>
        </main>
    )

}

export default SetPasswordPage;